const stickedRightStyles = {
  ml: 'auto',
  bg: 'white',
  right: '0px',
  position: 'sticky',
  boxShadow: '-4px 0 8px 0 rgba(0, 28, 36, 0.1)',
};

export {
  stickedRightStyles,
};
